import Sidebar from './Sidebar.js';
import "bootstrap/dist/css/bootstrap.min.css";

import { Chart as ChartJS } from 'chart.js/auto';
import { Pie, Bar } from 'react-chartjs-2'

import { useEffect,useState } from 'react';

function Analytics() {

    const [orderData,setOrderData] = useState([[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]])
    const [profitData,setProfitData] = useState([[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]])
    const [costData,setCostData] = useState([[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]])


    useEffect(()=>{
        loadFunc();
    },[])

    const loadFunc = async() => {
    
        const dataToPass = {
            method: 'GET',
            headers: { 'Content-Type':'application/json' },
        }

        const dataToPass2 = {
            method: 'GET',
            headers: { 'Content-Type':'application/json' },
        }

        try {
            const resp = await fetch("https://cfryapi.onrender.com/getAllMonth",dataToPass).then(resp=>resp.json())
            const resp2 = await fetch("https://cfryapi.onrender.com/getMenu",dataToPass2).then(resp=>resp.json())

            const menuData = []

            resp2.forEach(e=>
                menuData.push(e)
            )

            const orderDataTemp = [[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]]
            const profitDataTemp = [[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]]
            const costDataTemp = [[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]]
            
            resp.forEach(e=>orderDataTemp[parseInt(e.month)-1][0]=e.order[0])
            resp.forEach(e=>orderDataTemp[parseInt(e.month)-1][1]=e.order[1])
            resp.forEach(e=>orderDataTemp[parseInt(e.month)-1][2]=e.order[2])
            resp.forEach(e=>orderDataTemp[parseInt(e.month)-1][3]=e.order[3])
            resp.forEach(e=>orderDataTemp[parseInt(e.month)-1][4]=e.order[4])

            resp.forEach(e=>costDataTemp[parseInt(e.month)-1][0]=e.order[0]*menuData[0].cost)
            resp.forEach(e=>costDataTemp[parseInt(e.month)-1][1]=e.order[1]*menuData[1].cost)
            resp.forEach(e=>costDataTemp[parseInt(e.month)-1][2]=e.order[2]*menuData[2].cost)
            resp.forEach(e=>costDataTemp[parseInt(e.month)-1][3]=e.order[3]*menuData[3].cost)
            resp.forEach(e=>costDataTemp[parseInt(e.month)-1][4]=e.order[4]*menuData[4].cost)

            resp.forEach(e=>profitDataTemp[parseInt(e.month)-1][0]=e.order[0]*(menuData[0].price-menuData[0].cost))
            resp.forEach(e=>profitDataTemp[parseInt(e.month)-1][1]=e.order[1]*(menuData[1].price-menuData[1].cost))
            resp.forEach(e=>profitDataTemp[parseInt(e.month)-1][2]=e.order[2]*(menuData[2].price-menuData[2].cost))
            resp.forEach(e=>profitDataTemp[parseInt(e.month)-1][3]=e.order[3]*(menuData[3].price-menuData[3].cost))
            resp.forEach(e=>profitDataTemp[parseInt(e.month)-1][4]=e.order[4]*(menuData[4].price-menuData[4].cost))

            setOrderData(orderDataTemp)
            setCostData(costDataTemp)
            setProfitData(profitDataTemp)

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className='row'>
            <div className='col-2'>
                <Sidebar selected={'Analytics'}/>
            </div>
            <div className='col-10  container d-flex flex-column'>
                <div className='row pt-4 pb-4'>
                    <div className='col-4 sqr'>
                        <Pie
                            data= {{
                                labels: ['Cappucino','Latte', 'Affogato','Americano', 'Espresso'],
                                datasets: [
                                    {
                                    label: 'Total Profits',
                                    data: [Array.from({length:12}, (_,i) => profitData[i][0]).reduce((p, a) => p + a, 0), Array.from({length:12}, (_,i) => profitData[i][1]).reduce((p, a) => p + a, 0), Array.from({length:12}, (_,i) => profitData[i][2]).reduce((p, a) => p + a, 0), Array.from({length:12}, (_,i) => profitData[i][3]).reduce((p, a) => p + a, 0), Array.from({length:12}, (_,i) => profitData[i][4]).reduce((p, a) => p + a, 0)],
                                    backgroundColor: ['#cbac85d0','#c4923ed0','#965015d0','#6a3005d0','#3e1e04d0'],
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Total Cost',
                                    data: [Array.from({length:12}, (_,i) => costData[i][0]).reduce((p, a) => p + a, 0), Array.from({length:12}, (_,i) => costData[i][1]).reduce((p, a) => p + a, 0), Array.from({length:12}, (_,i) => costData[i][2]).reduce((p, a) => p + a, 0), Array.from({length:12}, (_,i) => costData[i][3]).reduce((p, a) => p + a, 0), Array.from({length:12}, (_,i) => costData[i][4]).reduce((p, a) => p + a, 0)],
                                    backgroundColor: ['#cbac85d0','#c4923ed0','#965015d0','#6a3005d0','#3e1e04d0'],
                                    borderWidth: 1
                                    },
                                ],
                            }}

                            options={{
                                plugins: {
                                    legend: {
                                      display: true,
                                      position: 'bottom'
                                    },
                                    title: {
                                        display: true,
                                        text: 'Total Profits and Cost per Coffee Type'
                                      }
                                  }
                            }}
                        />
                    </div>
                    <div className='col-6 sqr mx-4'>
                        <Bar
                            data= {{
                                labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
                                datasets: [
                                    {
                                    label: 'Cappucino',
                                    data: Array.from({length:12}, (_,i) => orderData[i][0]),
                                    backgroundColor: '#cbac85b0',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Latte',
                                    data: Array.from({length:12}, (_,i) => orderData[i][1]),
                                    backgroundColor: '#c4923eb0',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Affogato',
                                    data: Array.from({length:12}, (_,i) => orderData[i][2]),
                                    backgroundColor: '#965015b0',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Americano',
                                    data: Array.from({length:12}, (_,i) => orderData[i][3]),
                                    backgroundColor: '#6a3005b0',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Espresso',
                                    data: Array.from({length:12}, (_,i) => orderData[i][4]),
                                    backgroundColor: '#3e1e04b0',
                                    borderWidth: 1
                                    },
                                ],
                            }}

                            options={{
                                plugins: {
                                    legend: {
                                      display: true,
                                      position: 'bottom'
                                    },
                                    title: {
                                        display: true,
                                        text: 'Monthly Orders per Coffee Type'
                                      }
                                  },
                                scales: {
                                x: {
                                stacked: true,
                                },
                                y: {
                                stacked: true,
                                },
                                }
                            }}
                        />
                    </div>
                </div>
                <div className='row pb-4'>
                    <div className='col-5 sqr'>
                        <Bar
                            data= {{
                                labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
                                datasets: [
                                    {
                                    label: 'Cappucino',
                                    data: Array.from({length:12}, (_,i) => profitData[i][0]),
                                    backgroundColor: '#cbac85',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Latte',
                                    data: Array.from({length:12}, (_,i) => profitData[i][1]),
                                    backgroundColor: '#c4923e',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Affogato',
                                    data: Array.from({length:12}, (_,i) => profitData[i][2]),
                                    backgroundColor: '#965015',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Americano',
                                    data: Array.from({length:12}, (_,i) => profitData[i][3]),
                                    backgroundColor: '#6a3005',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Espresso',
                                    data: Array.from({length:12}, (_,i) => profitData[i][4]),
                                    backgroundColor: '#3e1e04',
                                    borderWidth: 1
                                    },
                                ],
                            }}

                            options={{
                                plugins: {
                                    legend: {
                                      display: true,
                                      position: 'bottom'
                                    },
                                    title: {
                                        display: true,
                                        text: 'Monthly Profits per Coffee Type'
                                      }
                                  },
                                scales: {
                                x: {
                                stacked: false,
                                },
                                y: {
                                stacked: false,
                                },
                                }
                            }}
                        />
                    </div>
                    <div className='col-5 sqr mx-4'>
                    <Bar
                            data= {{
                                labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
                                datasets: [
                                    {
                                    label: 'Cappucino',
                                    data: Array.from({length:12}, (_,i) => costData[i][0]),
                                    backgroundColor: '#cbac85',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Latte',
                                    data: Array.from({length:12}, (_,i) => costData[i][1]),
                                    backgroundColor: '#c4923e',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Affogato',
                                    data: Array.from({length:12}, (_,i) => costData[i][2]),
                                    backgroundColor: '#965015',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Americano',
                                    data: Array.from({length:12}, (_,i) => costData[i][3]),
                                    backgroundColor: '#6a3005',
                                    borderWidth: 1
                                    },
                                    {
                                    label: 'Espresso',
                                    data: Array.from({length:12}, (_,i) => costData[i][4]),
                                    backgroundColor: '#3e1e04',
                                    borderWidth: 1
                                    },
                                ],
                            }}

                            options={{
                                plugins: {
                                    legend: {
                                      display: true,
                                      position: 'bottom'
                                    },
                                    title: {
                                        display: true,
                                        text: 'Monthly Cost per Coffee Type'
                                      }
                                  },
                                scales: {
                                x: {
                                stacked: false,
                                },
                                y: {
                                stacked: false,
                                },
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
  }
  
export default Analytics;